<!-- <button (click)="selectMenuItem(ActionType.Rename)" mat-menu-item *ngIf="!isProtectedColumn">
<mat-icon svgIcon="icon_field_type_text_16" />
<span>Rename</span>
</button> -->
@if (!isProtectedColumn && !notEditable) {
  <button (click)="selectMenuItem(ActionType.Edit)" mat-menu-item>
    <mat-icon svgIcon="icon_edit_16" />
    <span>{{ column?.isInline ? 'Edit linked fields' : 'Edit field' }}</span>
  </button>
}
@if (!column?.isInline && !notEditable) {
  <button (click)="selectMenuItem(ActionType.InsertLeft)" mat-menu-item>
    <mat-icon svgIcon="icon_direction_left_16" />
    <span>Insert left</span>
  </button>
}
@if (!column?.isInline && !notEditable) {
  <button (click)="selectMenuItem(ActionType.InsertRight)" mat-menu-item>
    <mat-icon svgIcon="icon_direction_right_16" />
    <span>Insert right</span>
  </button>
}
<button (click)="selectMenuItem(ActionType.SortAZ)" mat-menu-item>
  <mat-icon svgIcon="icon_sort_ascending_16" />
  <span>Sort A-Z</span>
</button>
<button (click)="selectMenuItem(ActionType.SortZA)" mat-menu-item>
  <mat-icon svgIcon="icon_sort_descending_16" />
  <span>Sort Z-A</span>
</button>
@if (referencesCount) {
  <button
    (click)="selectMenuItem(ActionType.FindUsages)"
    data-cy="BlazeTable:Column:FindUsages"
    mat-menu-item
  >
    <mat-icon svgIcon="icon_search_16" />
    <span>Find usages</span>
  </button>
}
@if (
  !isProtectedColumn &&
  !isDisplayColumnProtected &&
  !column?.isInline &&
  column?.format?.formatType !== 'SecureText'
) {
  <button (click)="selectMenuItem(ActionType.SetAsDisplayColumn)" mat-menu-item>
    <mat-icon svgIcon="icon_asterix_16" />
    <span>Set as display column</span>
  </button>
}
@if (columnsCount > 1 && !isProtectedColumn && !column?.isInline && !notEditable) {
  <button (click)="selectMenuItem(ActionType.Delete)" mat-menu-item class="!text-warn">
    <mat-icon svgIcon="icon_trash_16" />
    <span class="!text-warn">Delete</span>
  </button>
}
